const datasetMarkdownActions = {
  CLOSE_DATASET_MARKDOWN: 'CLOSE_DATASET_MARKDOWN',
  FETCH_DATASET_MARKDOWN: 'FETCH_DATASET_MARKDOWN',
  FETCH_DATASET_MARKDOWN_ERROR: 'FETCH_DATASET_MARKDOWN_ERROR',
  FETCH_DATASET_MARKDOWN_SUCCESS: 'FETCH_DATASET_MARKDOWN_SUCCESS',
};

export const datasetMarkdownCategories = ['open'];

export default datasetMarkdownActions;
